import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Divider } from '../Divider';
import { TextButton } from '../TextButton';
import styles from './MenuContextualAction.module.scss';
export function MenuContextualAction(props) {
    const { title: text, intent, testId, icon, onClick, onMouseDown, disabled, disabledTooltip } = props;
    // Narrow on `props` directly — destructuring `noBi`/`bi` would lose the BiProps discrimination.
    const biForward = props.noBi ? {
        noBi: props.noBi
    } : {
        bi: props.bi
    };
    const button = /*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({}, biForward), {
        underline: "none",
        weight: "normal",
        className: styles.root,
        intent: intent,
        testId: testId,
        prefixIcon: icon,
        disabled: disabled,
        tooltip: disabled && disabledTooltip ? {
            title: disabledTooltip,
            placement: 'top'
        } : undefined,
        onClick: onClick,
        onMouseDown: onMouseDown,
        children: text
    }));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                margin: 0
            }),
            disabled ? /*#__PURE__*/ _jsx("div", {
                onMouseDown: (e)=>e.preventDefault(),
                children: button
            }) : button
        ]
    });
}
